import { render, staticRenderFns } from "./CategoryMenuFoodCard.vue?vue&type=template&id=129a2e0a&scoped=true"
import script from "./CategoryMenuFoodCard.vue?vue&type=script&lang=js"
export * from "./CategoryMenuFoodCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryMenuFoodCard.vue?vue&type=style&index=0&id=129a2e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a2e0a",
  null
  
)

export default component.exports